(function($) {
    $(".nav-search").click(function(e) {
       e.preventDefault();

       $(".search-form").toggleClass("active");
    });

    $(document).on('click','.search-form .close',function(){
        $(".search-form").toggleClass("active");
    });

    $(".toggle-nav").click(function() {
        $(".nav-container").toggle();
    });
})(jQuery);